import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type AddOnsState = {
  purchasedNoomPremium: boolean;
  purchasedFastForward: boolean;
  purchasedNoomSummit: boolean;
  purchasedMealDelivery: boolean;
  purchasedSnacks: boolean;
  skippedNoomSummit: boolean;
  skippedMealDelivery: boolean;
  skippedSnackDelivery: boolean;
};

const initialState: AddOnsState = {
  purchasedNoomPremium: false,
  purchasedFastForward: false,
  purchasedNoomSummit: false,
  purchasedMealDelivery: false,
  purchasedSnacks: false,
  skippedNoomSummit: false,
  skippedMealDelivery: false,
  skippedSnackDelivery: false,
};

const addOnsSlice = createSlice({
  name: "addOns",
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    setPurchasedNoomPremium(state, action: PayloadAction<boolean>) {
      state.purchasedNoomPremium = action.payload;
    },
    setPurchasedFastForward(state, action: PayloadAction<boolean>) {
      state.purchasedFastForward = action.payload;
    },
    setPurchasedNoomSummit(state, action: PayloadAction<boolean>) {
      state.purchasedNoomSummit = action.payload;
    },
    setPurchasedMealDelivery(state, action: PayloadAction<boolean>) {
      state.purchasedMealDelivery = action.payload;
    },
    setPurchasedSnacks(state, action: PayloadAction<boolean>) {
      state.purchasedSnacks = action.payload;
    },
    setSkippedNoomSummit(state, action: PayloadAction<boolean>) {
      state.skippedNoomSummit = action.payload;
    },
    setSkippedMealDelivery(state, action: PayloadAction<boolean>) {
      state.skippedMealDelivery = action.payload;
    },
    setSkippedSnackDelivery(state, action: PayloadAction<boolean>) {
      state.skippedSnackDelivery = action.payload;
    },
    /* eslint-enable no-param-reassign */
  },
});

export const {
  setPurchasedNoomPremium,
  setPurchasedFastForward,
  setPurchasedNoomSummit,
  setPurchasedMealDelivery,
  setPurchasedSnacks,
  setSkippedNoomSummit,
  setSkippedMealDelivery,
  setSkippedSnackDelivery,
} = addOnsSlice.actions;

export default addOnsSlice;
